import React from 'react';
import { Pagination } from 'react-admin';

export const CustomPagination = props => <Pagination rowsPerPageOptions={[]} {...props} />;
